import React, { useState } from 'react';
import "../LandingPage.css";
import { Layout, Button, Typography, Row, Col, Card, Collapse, Spin, List, Tooltip } from 'antd';
import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  UserOutlined,
  BulbOutlined,
  FileTextOutlined,
  LockOutlined,
  SecurityScanOutlined,
  LoadingOutlined,
  ReloadOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import screenImage from '../screen.png';
import featureImage2 from '../feature2.png';
import featureImage3 from '../feature3.png';
import person1 from '../person1.png';
import ReactMarkdown from "react-markdown";
import featurebg1 from '../featurebg1.svg';
import featurebg2 from '../featurebg2.svg';
import featurebg3 from '../featuregb3.svg';

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

//Fake analysis data
const demoAnalyses = {
  Helhetsanalyse: "Psykologen kan gi mer rom for stillhet og refleksjon, da en tendens til å fylle pauser kan begrense klientens prosess. Noen spørsmål formuleres ledende, og en mer utforskende tilnærming kan gi dypere innsikt...(Fortsetter)",
  Metodetips: "Bruk av sokratiske spørsmål kan fremme refleksjon hos klienten. Økt bevissthet rundt non-verbal kommunikasjon og tilpasset tempo kan styrke den terapeutiske alliansen...(Fortsetter)"
};

const aspectTitles = {
  Helhetsanalyse: "Helhetsanalyse",
  Metodetips: "Metodetips",
};

const aspectMessages = {
  Helhetsanalyse: "Analyserer og identifiserer forbedringsområder i samtalen...",
  Metodetips: "Analyserer og utarbeider metodetips for samtalen...",
};

// yrker vi støtter
const professions = ["Psykologer", "Terapeuter", "Barnevernspedagoger", "Coacher"];

// Features til features delen
const features = [
  {
    title: "Automatisk transkribering",
    description: "Spar tid med presis transkribering av alle samtaler i sanntid.",
    icon: <UserOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#EAF4F4",
  },
  {
    title: "Analyseverktøy",
    description: "Få dypere innsikt i samtalene med avanserte analyseverktøy.",
    icon: <BulbOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#FDF3E7",
  },
  {
    title: "Samtaleoppsummering",
    description: "Få automatiske oppsummeringer av samtalene som fremhever viktige punkter og temaer.",
    icon: <FileTextOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#E8EAF6",
  },
  {
    title: "Enkel dokumentasjon",
    description: "Lag journalnotater raskere med automatiserte forslag.",
    icon: <CheckCircleOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#F6EAE4",
  },
  {
    title: "Anonymisering av innhold",
    description: "Alle stedsnavn og personnavn blir automatisk anonymisert for å ivareta personvernet.",
    icon: <SecurityScanOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#E8F0F5",
  },
  {
    title: "Sikkerhet",
    description: "Vår løsning er bygget med sikkerhet i fokus og følger de strengeste personvernkravene.",
    icon: <LockOutlined style={{ fontSize: "32px", color: "#230518" }} />,
    bgColor: "#E9F5EA",
  },
];


const HomePage = () => {
  const [activeKey, setActiveKey] = useState(null);
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  // Fake card loading
  const [loading, setLoading] = useState(false);
  const [analysisText, setAnalysisText] = useState("");

  const handleAnalyze = () => {
    setLoading(true);
    setAnalysisText("");
    setTimeout(() => {
      setLoading(false);
      setAnalysisText(
        "Klienten uttrykte bekymringer knyttet til vedvarende stress på arbeidsplassen og utfordringer med å sette grenser overfor kolleger. Hen beskrev en følelse av utmattelse og frustrasjon over en stadig økende arbeidsmengde, noe som har påvirket både søvn og generell livskvalitet..(Fortsetter)"
      );
    }, 2000);
  };

  // Fake analysis loading
  const [loadingAspect, setLoadingAspect] = useState(null);
  const [activeAnalysis, setActiveAnalysis] = useState(null);
  const [analysisResults, setAnalysisResults] = useState({});

  const handleAnalyzeAnalytics = (aspect) => {
    setLoadingAspect(aspect);
    setTimeout(() => {
      setLoadingAspect(null);
      setAnalysisResults((prev) => ({
        ...prev,
        [aspect]: demoAnalyses[aspect],
      }));
    }, 2000);
  };


  return (


    <Layout style={{ backgroundColor: 'white' }}>
      {/* Main Content Section */}
      <Content className="hero-top" style={{ padding: "20px" }}>
        <Content >
          {/* Hero Section */}
          <div
            className="hero-container"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "40px",
              maxWidth: "1200px",
              margin: "40px auto 20px",
              padding: "0 20px",
              textAlign: "left",
              flexWrap: "wrap",
            }}
          >
            {/* Left Side - Text Content */}
            <div style={{ flex: "1", minWidth: "300px", maxWidth: "600px" }}>
              <Paragraph
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#f26549",
                  textTransform: "uppercase",
                  marginBottom: 10,
                }}
              >
                TA MED AI PÅ BEHANDLINGSROMMET
              </Paragraph>
              <Title className='custom-heading' level={1} style={{ marginTop: "5px" }}>Slipp notatpresset. Vær til stede i samtalen.</Title>
              <Paragraph
                style={{
                  fontSize: "1.2rem",
                  margin: "20px 0",
                  fontWeight: "300",
                  lineHeight: "1.8",
                  backgroundColor:"#fffaf8",
                  padding:"20px",
                }}
              >
                Kipler transkriberer og strukturerer samtalene dine automatisk, og gir deg ferdige journalnotater og innsikt etter timen. Ingen forstyrrelser. Ingen stress.
              </Paragraph>
              <a href="https://app.kipler.ai" target="_blank" rel="noopener noreferrer">
                <Button type="primary" size="large" style={{ backgroundColor: "#f26549", fontWeight: 600 }}>
                  Prøv gratis nå <ArrowRightOutlined />
                </Button>
              </a>
            </div>

            {/* Right Side - Image */}
            <div style={{ flex: "1", minWidth: "300px", maxWidth: "320px", textAlign: "center" }}>
              <img
                src={person1}
                alt="Person 1"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>

          {/* Options Section */}
          <div
            className="options-container"
            style={{ marginTop: "40px", marginBottom: "40px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "40px",
                flexWrap: "wrap",
              }}
            >
              <div className="option-item" style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{ fontSize: "24px", color: "#f26549 ", marginRight: "10px" }}
                />
                <Paragraph style={{ margin: 0, fontSize: "1.2rem", fontWeight: "300" }}>
                  Sammendrag og journalnotat
                </Paragraph>
              </div>
              <div className="option-item" style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{ fontSize: "24px", color: "#f26549 ", marginRight: "10px" }}
                />
                <Paragraph style={{ margin: 0, fontSize: "1.2rem", fontWeight: "300" }}>
                  AI analyse og innsikt
                </Paragraph>
              </div>
              <div className="option-item" style={{ display: "flex", alignItems: "center" }}>
                <CheckCircleOutlined
                  style={{ fontSize: "24px", color: "#f26549 ", marginRight: "10px" }}
                />
                <Paragraph style={{ margin: 0, fontSize: "1.2rem", fontWeight: "300" }}>
                  Sikkert og kryptert
                </Paragraph>
              </div>
            </div>
          </div>


          {/* Image Section Placeholder with Shadow Box */}
          <div
            className="image-section"
            style={{
              position: 'relative',
              maxWidth: '800px',
              margin: '20px auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '40px',
            }}
          >
            {/* Main Image */}
            <img
              src={screenImage}
              alt="Kipler AI"
              style={{
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                width: '100%',
                height: 'auto',
                zIndex: 2,
                borderRadius: '8px',
                position: 'relative',
              }}
            />

            {/* Shadow Box */}
            <div
              style={{
                position: 'absolute',
                backgroundColor: '#fffaf8',
                width: 'calc(100% + 20px)',
                height: 'calc(100% + 20px)',
                right: '15px',
                top: '20px',
                zIndex: 1,
                borderRadius: '8px',
              }}
            />

            {/* Overlay Image */}
            <img
              src={featureImage2}
              alt="Feature"
              style={{
                position: 'absolute',
                bottom: '-80px',
                right: '-20px',
                width: '80%',
                boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                borderRadius: '8px',
                zIndex: 3,
              }}
            />
          </div>
        </Content>
      </Content>

      {/* Header with Paragraph */}
      <Content
        style={{
          textAlign: 'center',
          marginTop: '60px',
          paddingLef: "10px",
          paddingRight: "10px",
          background: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <div style={{ maxWidth: '1200px', textAlign: 'center' }}>
          <Title level={2} style={{}}>Jobb mer effektivt</Title>
          <Paragraph
            style={{
              fontSize: '1.2rem',
              margin: '20px auto',
              fontWeight: '300',
              paddingLeft: "20px",
              paddingRight: "20px",
              maxWidth: '600px',
              lineHeight: "1.8",
            }}
          >
            Ved å ta med Kipler AI på behandlingsrommet kan du jobbe mer effektivt og få bedre innsikt i samtalene.
          </Paragraph>
        </div>

      </Content>
      {/* Yrker som kort */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "15px",
          flexWrap: "wrap",
        }}
      >
        {professions.map((profession, index) => (
          <div
            key={index}
            style={{
              padding: "10px",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#Fdddc5",
              border: "none",
              fontSize: "1rem",
              fontWeight: "bold",
              color: "#f26549",
            }}
          >
            {profession}
          </div>
        ))}
      </div>
      {/* Feature Section */}
      <Content style={{ padding: "40px 0px", background: "white" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "40px" }}>

          {/* Feature 1: Automatisk Transkribering */}
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}>
            {/* Left Side - Custom Component */}
            <div style={{
              flex: "1", textAlign: "center", position: "relative", marginBottom: "20px", paddingTop: "80px", paddingBottom: "80px", backgroundImage: `url(${featurebg1})`,
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}>
              <Card
                title="Om samtalen"
                style={{
                  marginRight: "20px",
                  marginLeft: "20px",
                  maxWidth: 600,
                  minWidth: 280,
                  textAlign: "left",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                }}
              >
                {loading ? (
                  <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                    <Paragraph style={{ marginTop: 10 }}>Analyserer samtale...</Paragraph>
                  </div>
                ) : analysisText ? (
                  <Paragraph style={{ textAlign: "left" }}>{analysisText}</Paragraph>
                ) : (
                  <Paragraph>Klikk på "Analyser samtale" for å se en demoanalyse.</Paragraph>
                )}

                {!analysisText && (
                  <Button
                    type="primary"
                    size='large'
                    style={{ backgroundColor: "#230518", color: "white" }}
                    onClick={handleAnalyze}
                    disabled={loading}
                    icon={<ReloadOutlined />}
                  >
                    Analyser samtale
                  </Button>
                )}
              </Card>
            </div>

            {/* Right Side - Text Content */}
            <div style={{
              flex: "1",
              textAlign: "left",
              maxWidth: "500px",
              minWidth: "280px",
              lineHeight: "1.8",
              paddingRight: "20px",
              paddingLeft: "20px",
            }}>
              <Title level={3}>Spar tid med automatisk transkribering og journalnotat</Title>
              <Paragraph style={{ fontSize: "1.2rem", margin: "20px 0", fontWeight: "300", lineHeight: "1.8" }}>
                Spar tid på å la Kipler ta notater av samtalen og få automatiske oppsummeringer. Vi hjelper deg med å dokumentere samtalen på en enkel og effektiv måte.
              </Paragraph>
            </div>
          </div>

          {/* Feature 2: Analyseverktøy */}
          <div style={{
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
            padding: "20px 0",
          }}>
            {/* Left Side - Custom Component */}
            <div style={{
              flex: "1", textAlign: "center", position: "relative", marginBottom: "20px", backgroundImage: `url(${featurebg2})`,
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}>
              <Card
                style={{
                  height: "auto",
                  marginTop: 40,
                  marginBottom: 40,
                  marginLeft: 20,
                  marginRight: 20,
                  backgroundColor: "white",
                  maxWidth: "800px",
                  minWidth: "280px",
                  textAlign: "left",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                }}
                title="Analysekort demo"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 32,
                    flexWrap: "wrap",
                  }}
                >
                  {/* Left Side - List of Analyses */}
                  <div style={{ flex: 1, minWidth: 260 }}>
                    <h3
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 16,
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        Analyser samtalen
                      </span>
                    </h3>

                    <List
                      style={{ border: "none" }}
                      dataSource={Object.keys(demoAnalyses)}
                      renderItem={(aspect) => (
                        <List.Item
                          onClick={() => setActiveAnalysis(aspect)}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            padding: "12px 16px",
                            marginBottom: "8px",
                            borderRadius: "6px",
                            border: "1px solid #dfdfdf",
                            backgroundColor:
                              activeAnalysis === aspect ? "#230518" : "white",
                            color: activeAnalysis === aspect ? "white" : "#230518",
                          }}
                        >
                          <span>{aspectTitles[aspect]}</span>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              justifyContent: "flex-end",
                            }}
                          >
                            {analysisResults[aspect] && <div />}
                            {loadingAspect === aspect ? (
                              <Spin
                                size="small"
                                indicator={
                                  <LoadingOutlined
                                    style={{
                                      fontSize: 16,
                                      color: activeAnalysis === aspect
                                        ? "white"
                                        : "#17403E",
                                    }}
                                    spin
                                  />
                                }
                              />
                            ) : (
                              <ArrowRightOutlined
                                style={{
                                  fontSize: 16,
                                  color: activeAnalysis === aspect
                                    ? "white"
                                    : "#17403E",
                                }}
                              />
                            )}
                          </div>
                        </List.Item>
                      )}
                    />
                  </div>

                  {/* Right Side - Analysis Details */}
                  <div
                    style={{
                      flex: 2,
                      border: "1px solid #ddd",
                      padding: 20,
                      borderRadius: 6,
                      minWidth: 260,
                    }}
                  >
                    <h3 style={{ fontWeight: "bold", marginBottom: 8 }}>
                      {activeAnalysis
                        ? aspectTitles[activeAnalysis]
                        : "Detaljer om valgt analyse"}
                    </h3>

                    {activeAnalysis ? (
                      loadingAspect === activeAnalysis ? (
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <Spin />
                          <span>{aspectMessages[activeAnalysis] || "Analyserer..."}</span>
                        </div>
                      ) : analysisResults[activeAnalysis] ? (
                        <ReactMarkdown>{analysisResults[activeAnalysis]}</ReactMarkdown>
                      ) : (
                        <p>(Ingen resultat ennå for: {aspectTitles[activeAnalysis]})</p>
                      )
                    ) : (
                      <p>Velg en analyse i venstre liste.</p>
                    )}

                    {activeAnalysis && !analysisResults[activeAnalysis] && (
                      <Button
                        type="primary"
                        size="large"
                        style={{
                          marginTop: 16,
                          borderRadius: 6,
                          backgroundColor: "#230518",
                          color: "white",
                        }}
                        icon={<ReloadOutlined />}
                        onClick={() => handleAnalyzeAnalytics(activeAnalysis)}
                        loading={loadingAspect === activeAnalysis}
                      >
                        Gjennomfør analyse
                      </Button>
                    )}
                  </div>
                </div>
              </Card>
            </div>

            {/* Right Side - Text Content */}
<div style={{
  flex: "1",
  textAlign: "left",
  maxWidth: "500px",
  minWidth: "280px",
  lineHeight: "1.8",
  paddingRight: "20px",
  paddingLeft: "20px",
}}>
  <Title level={3}>Få innsikt med analyseverktøy og anbefalinger</Title>
  <Paragraph style={{ fontSize: "1.2rem", margin: "20px 0", fontWeight: "300", lineHeight: "1.8" }}>
    Kipler hjelper deg å forstå pasientens behov bedre – og gir forslag til videre utforskning og behandling. Vi støtter flere ulike terapiretninger, slik at innsikten du får er relevant for din metode:
  </Paragraph>
  <ul style={{ fontSize: "1.1rem", fontWeight: "300", paddingLeft: "20px" }}>
    <li style={{fontWeight:500}}>
      <Tooltip title="Fokus på tanker, følelser og atferd.">
        <strong>CBT</strong>
      </Tooltip>
    </li>
    <li style={{fontWeight:500}}>
      <Tooltip title="Forståelse av underliggende relasjonelle mønstre og ubevisste prosesser.">
        <strong>Psykodynamisk terapi</strong>
      </Tooltip>
    </li>
    <li style={{fontWeight:500}}>
      <Tooltip title="Aksept og verdibasert handling for økt psykologisk fleksibilitet.">
        <strong>ACT</strong>
      </Tooltip>
    </li>
    <li style={{fontWeight:500}}>
      <Tooltip title="Intensiv korttidsterapi med fokus på følelsesregulering og emosjonell bearbeiding.">
        <strong>ISTDP</strong>
      </Tooltip>
    </li>
    <li style={{fontWeight:500}}>
      <Tooltip title="Arbeid med følelser og tilknytning i nære relasjoner.">
        <strong>EFT</strong>
      </Tooltip>
    </li>
  </ul>
</div>
          </div>

          {/* Feature 3: Klient- og samtaleoversikt */}
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",

            flexWrap: "wrap",
            padding: "20px 0",
          }}>
            {/* Left Side - Image */}
            <div style={{
              flex: "1", textAlign: "center", position: "relative", marginBottom: "20px", backgroundImage: `url(${featurebg3})`,
              backgroundSize: "cover",
              backgroundPosition: "center", paddingTop: "80px", paddingBottom: "80px", paddingLeft: "20px", paddingRight: "20px"
            }}>
              <img
                src={featureImage3}
                alt="Hold oversikt over klienter"
                style={{
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                  width: "100%",
                  maxWidth: "550px",
                  minWidth: "280px",
                  zIndex: 2,
                  position: "relative",
                }}
              />
            </div>

            {/* Right Side - Text Content */}
            <div style={{
              flex: "1",
              textAlign: "left",
              maxWidth: "500px",
              minWidth: "280px",
              lineHeight: "1.8",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}>
              <Title level={3}>Hold oversikt over klienter og samtaler</Title>
              <Paragraph style={{ fontSize: "1.2rem", margin: "20px 0", fontWeight: "300", lineHeight: "1.8" }}>
                Få enkel tilgang til alle dine klienter og samtaler, og hold oversikt over tidligere samtaler og behandlingsforløp. Vi hjelper deg med å holde orden på alt du trenger.
              </Paragraph>
            </div>
          </div>



          {/* Call-to-action Button */}
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <a href="https://app.kipler.ai" target="_blank" rel="noopener noreferrer">
              <Button type="primary" size="large" style={{ backgroundColor: "#f26549 ", fontWeight:600 }}>
                Opprett bruker nå <ArrowRightOutlined />
              </Button>
            </a>
          </div>
        </div>
      </Content>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <div className="main-content" style={{ margin: "20px" }}>
          <Title
            level={2}
            style={{ paddingTop: "0px", color: "white" }}
          >
            Hva sier brukerne våre?
          </Title>
          <Row gutter={[16, 16]} style={{ marginTop: '40px' }}>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={true} style={{ boxShadow: "0 8px 16px 0 rgba(0,0,0,0.1)", backgroundColor: "#fffaf8", color: "#333333" }}>
                <div className="feedback-header">
                  <div className="stars">★★★★★</div>
                </div>
                <Paragraph style={{ fontSize: "1.0rem", lineHeight: "1.8", color: "#333333" }}>
                  "Kipler har spart meg enormt mye tid. Jeg kan nå fokusere mer på pasientene mine."
                </Paragraph>
                <div className="user-info">
                  <Paragraph style={{ fontWeight: 'bold', marginLeft: '0px', color: "#333333" }}>
                    – Terapeut, Oslo
                  </Paragraph>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={true} style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.1)", backgroundColor: "#fffaf8" }}>
                <div className="feedback-header">
                  <div className="stars">★★★★★</div>
                </div>
                <Paragraph style={{ fontSize: "1.0rem", lineHeight: "1.8", color: "#333333" }}>
                  "Analyseverktøyene gir meg dypere innsikt i samtalene, noe som forbedrer kvaliteten på behandlingen."
                </Paragraph>
                <div className="user-info">
                  <Paragraph style={{ fontWeight: 'bold', marginLeft: '10px', color: "#333333" }}>
                    – Psykolog, Bergen
                  </Paragraph>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={true} style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.1)", backgroundColor: "#fffaf8" }}>
                <div className="feedback-header">
                  <div className="stars">★★★★★</div>
                </div>
                <Paragraph style={{ fontSize: "1.0rem", lineHeight: "1.8", color: "#333333" }}>
                  "Enkel dokumentasjon og transkribering har gjort hverdagen min mye enklere."
                </Paragraph>
                <div className="user-info">
                  <Paragraph
                    style={{ fontWeight: 'bold', marginLeft: '10px', verticalAlign: "middle", color: "#333333" }}
                  >
                    – Psykolog, Trondheim
                  </Paragraph>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Features Section */}
      <div style={{ backgroundColor: "white", padding: "40px 20px", textAlign: "center" }}>
        <Title level={2} style={{ color: "#230518" }}>Dette får du</Title>
        <Paragraph style={{ fontSize: "1.2rem", fontWeight: "300", maxWidth: "600px", margin: "0 auto" }}>
          Løsningen skreddersys til din behandlingsform og tilpasser seg din stil.
        </Paragraph>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "30px",
            maxWidth: "1200px",
            margin: "40px auto 0",
          }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                background: "white",
                borderRadius: "12px",
                padding: "40px 25px",
                textAlign: "center",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.08)";
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  backgroundColor: feature.bgColor,
                }}
              >
                {feature.icon}
              </div>
              <Title level={4} style={{ color: "#230518" }}>{feature.title}</Title>
              <Paragraph style={{ fontSize: "1.1rem", fontWeight: "300" }}>
                {feature.description}
              </Paragraph>
            </div>
          ))}
        </div>
      </div>



      {/* Pricing Section */}
      <div id="pris" className='container-price'
        style={{
          padding: "40px 20px 60px 20px",
          textAlign: 'center',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Title level={1} style={{ marginBottom: '20px', color: "black" }}>
          Få full tilgang - Prøv gratis i 7 dager
        </Title>
        <Paragraph
          style={{ marginBottom: '40px', color: "black", fontSize: "1.2rem", fontWeight: "300" }}
        >
          Få full tilgang til alle funksjoner og opplev hvordan Kipler kan gjøre arbeidet ditt enklere.
        </Paragraph>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          {/* Basic Plan */}

          {/* <Card
              style={{
                maxWidth: '480px',
                border: '1px solid #ddd',
                borderRadius: '8px',
                textAlign: 'left',
              }}
            >
              <div style={{ padding: '20px' }}>
                <Title level={3}>Basic</Title>
                <Paragraph style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#17403E' }}>
                  NOK 990,- / mnd
                </Paragraph>
                <ul style={{ listStyleType: 'none', padding: 0, fontSize: '1rem' }}>
                  <li style={{ marginBottom: "10px" }}>
                    <CheckCircleOutlined
                      style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                    />{" "}
                    Automatisk transkribering
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <CheckCircleOutlined
                      style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                    />{" "}
                    Enkle oppsummeringer
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <CheckCircleOutlined
                      style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                    />{" "}
                    Personvern og sikkerhet
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <span style={{ textDecoration: 'line-through', color: '#bbb' }}>
                      <CloseOutlined
                        style={{ color: 'red', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                      />
                      Avanserte analyseverktøy
                    </span>
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <span style={{ textDecoration: 'line-through', color: '#bbb' }}>
                      <CloseOutlined
                        style={{ color: 'red', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                      />
                      Anbefalinger for behandling
                    </span>
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <span style={{ textDecoration: 'line-through', color: '#bbb' }}>
                      <CloseOutlined
                        style={{ color: 'red', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }}
                      />
                      Prioritert kundestøtte
                    </span>
                  </li>
                </ul>
                <a href="https://app.kipler.ai" target="_blank" rel="noopener noreferrer">
                  <Button type="primary" block style={{ marginTop: '20px', backgroundColor: '#15524F' }}>
                    Velg Basic
                  </Button>
                </a>
              </div>
            </Card>
           */}

          {/* Premium Plan */}

          <Card
            style={{
              maxWidth: '480px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              textAlign: 'left',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}
          >

            <div style={{ paddingLeft: '20px', paddingRight: "20px", paddingBottom: "20px" }}>
              <Title level={3}>Personlig</Title>
              <Paragraph style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#f26549 ' }}>
                NOK 1290,- / mnd
              </Paragraph>
              <ul style={{ listStyleType: 'none', padding: 0, fontSize: '1rem' }}>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Automatisk transkribering
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Opsummeringer og journalnotat
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Personvern og sikkerhet
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Avanserte analyseverktøy
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Anbefalinger for behandling
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem", fontWeight: "300" }} /> Prioritert kundestøtte
                </li>
              </ul>
              <a href="https://app.kipler.ai" target="_blank" rel="noopener noreferrer">
                <Button type="primary" size="large" block style={{ marginTop: '20px', backgroundColor: '#f26549 ', fontWeight:600 }}>
                  Prøv gratis i 7 dager
                </Button>
              </a>
            </div>
          </Card>

          {/*Kontakt oss for avtale*/}

          <Card
            style={{
              maxWidth: '360px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              textAlign: 'left',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              backgroundColor: '#F9F9F9',
              display: 'flex',
              flexDirection: 'column',
              height: '480px',
            }}
          >
            <div style={{ paddingLeft: '20px', paddingRight:"20px", paddingBottom:"20px", flexGrow: 1 }}>
              <Title level={3} style={{ }}>Klinikker og team</Title>
              <Paragraph style={{ fontSize: '1rem' }}>
                Ønsker du å gi flere ansatte tilgang til Kipler?
                Vi tilbyr bedriftsavtaler for klinikker og team som trenger en skreddersydd løsning.
              </Paragraph>
              <ul style={{ listStyleType: 'none', padding: 0, fontSize: '1rem' }}>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem" }} />
                  Fleksible lisensavtaler
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem" }} />
                  Administrasjonsverktøy for team
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <CheckCircleOutlined style={{ color: '#17403E', marginRight: '10px', fontSize: "1.2rem" }} />
                  Prioritert kundestøtte
                </li>
              </ul>
            </div>
            <div style={{ paddingLeft: '20px', paddingRight:"20px", paddingTop:"38px", textAlign: 'center' }}>
            <Button 
      type="default"
      size='large' 
      block 
      style={{ borderColor: '#230518', color: '#230518' }}
      onClick={() => {
        if (window.tidioChatApi) {
          window.tidioChatApi.open();
        } else {
          console.warn("Tidio-chat er ikke lastet inn.");
        }
      }}
    >
      Kontakt oss for en avtale
    </Button>
            </div>
          </Card>



        </div>
      </div>

      {/* FAQ*/}
      <div className="faq-section">
        <div className="faq-container">
        <Title level={2} style={{ textAlign: 'center' }}>
  Ofte stilte spørsmål
</Title>
<Paragraph style={{ fontSize: "1.2rem", fontWeight: "300", textAlign: "center", marginBottom:"10px", paddingLeft:"20px", paddingRight:"20px" }}>
  Finner du ikke det du leter etter? Skriv til oss så svarer vi deg så fort vi kan.
</Paragraph>
<div style={{ display: 'flex', justifyContent: 'center', marginBottom:"20px"}}>
  <Button
    type="secondary"
    icon={<MessageOutlined />}
    size="large"
    style={{
      borderColor: '#f26549 ',
      color: '#f26549',
      padding: '12px 24px',
      fontSize: '1rem',
      borderRadius: '8px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    }}
    onClick={() => {
      if (window.tidioChatApi) {
        window.tidioChatApi.open();
      } else {
        console.warn("Tidio-chat er ikke lastet inn.");
      }
    }}
  >
    Chat med oss
  </Button>
</div>
          <Collapse
            style={{ backgroundColor: "transparent", paddingLeft: "20px", paddingRight: "20px" }}
            accordion
            activeKey={activeKey}
            onChange={handleToggle}
            expandIconPosition="right"
            expandIcon={({ isActive }) => (
              <ArrowRightOutlined
                rotate={isActive ? 90 : 0}
                style={{ fontSize: '20px', verticalAlign: 'middle' }}
              />
            )}
            bordered={false}
          >
            <Panel
              style={{
                marginBottom: "15px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Hvordan fungerer Kipler?</b>}
              key="1"
              className="faq-panel"
            >
              <p>
                Kipler bruker avansert AI for å transkribere samtaler i sanntid og gir fullstendig transkripsjon av samtalen samtidig som vi lager et sammendrag og ferdig journalnotat. Du kan også få innsikt i samtalen og anbefalinger for videre behandling ved hjelp av AI.
              </p>
            </Panel>
            <Panel
              style={{
                marginBottom: "15px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Er dataene mine sikre?</b>}
              key="2"
              className="faq-panel"
            >
              <p>
                Ja, sikkerhet og personvern er vår høyeste prioritet. Vi følger alle relevante
                forskrifter for å ivareta dine data.
              </p>
            </Panel>
            <Panel
              style={{
                marginBottom: "15px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Kan jeg prøve Kipler gratis?</b>}
              key="3"
              className="faq-panel"
            >
              <p>
                Ja, vi tilbyr en gratis prøveperiode slik at du kan oppleve hvordan løsningen
                fungerer i praksis.
              </p>
            </Panel>
            <Panel
              style={{
                marginBottom: "15px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Hva slags analyser kan Kipler gjøre?</b>}
              key="4"
              className="faq-panel"
            >
              <p>
                Vi gjør en analyse av samtalen og gir deg innsikt i ulike aspekter som tonefall, emosjoner og temaer som blir diskutert. Dette gir deg en bedre forståelse av samtalen og kan hjelpe deg med å forbedre behandlingen.
              </p>
            </Panel>
            <Panel
              style={{
                marginBottom: "15px",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Lagrer dere opptaket som gjøres av samtalen?</b>}
              key="5"
              className="faq-panel"
            >
              <p>
                Vi lagrer ikke opptaket av samtalen, den slettes så fort transkriberingen er ferdig. Vi lagrer kun transkripsjonen og analysen av samtalen.
              </p>
            </Panel>
            <Panel
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "8px",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)"
              }}
              header={<b>Hvilke språk støttes?</b>}
              key="6"
              className="faq-panel"
            >
              <p>
                Kipler støtter for øyeblikket kun norsk, men vi har planer om å utvide til flere
                språk.
              </p>
            </Panel>

          </Collapse>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
